import { toPascalCase } from '@cli-utils/text.js'

export function defaultValueFromHandlerName(sourceName: string): string {
  return `applyDefaultValueFrom${toPascalCase(sourceName)}`
}
